import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {assertOttopilotPathIsLeftover} from "~/workspaceConfig/ottopilotLeftoverPath";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottopilot/_ottopilotScaffold")({
    beforeLoad: ({location}) => {
        assertOttopilotPathIsLeftover(location.pathname);
    },
    loader: async ({context}) => {
        return {
            accessibleWorkspaces: context.accessibleWorkspaces,
            workspace: context.workspace,
            organizationalUnits: context.organizationalUnits,
            productCatalogue: context.productCatalogue,
            users: context.users,
            workspaceUser:
                context.currentWorkspaceUser
                ?? context.users.find((user) => user.userId === context.authenticationStatus.heimdallUser.id)
                ?? null,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
            heimdallUser: context.authenticationStatus.heimdallUser,
            // subscriptionDetails: context.subscriptionDetails,
            // pricingPlanNudgeStatus: context.pricingPlanNudgeStatus,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
